export const GET_SUBCOINSELLER = "GET_SUBCOINSELLER";
export const GET_SUBCOINSELLER_UNIQUEID = "GET_SUBCOINSELLER_UNIQUEID";

export const ADD_SUBCOINSELLER = "ADD_SUBCOINSELLER";
export const EDIT_SUBCOINSELLER = "EDIT_SUBCOINSELLER";
export const DELETE_SUBCOINSELLER = "DELETE_SUBCOINSELLER";

export const OPEN_SUBCOINSELLER_DIALOGUE = "OPEN_SUBCOINSELLER_DIALOGUE";
export const CLOSE_SUBCOINSELLER_DIALOGUE = "CLOSE_SUBCOINSELLER_DIALOGUE";

export const ADD_SUBCOIN_OPEN_DIALOGUE = "ADD_SUBCOIN_OPEN_DIALOGUE";
export const ADD_SUBCOIN_CLOSE_DIALOGUE = "ADD_SUBCOIN_CLOSE_DIALOGUE";
export const ADD_SUBCOIN_BY_ADMIN = "ADD_SUBCOIN_BY_ADMIN";

export const LESS_SUBCOIN_OPEN_DIALOGUE = "LESS_SUBCOIN_OPEN_DIALOGUE";
export const LESS_SUBCOIN_CLOSE_DIALOGUE = "LESS_SUBCOIN_CLOSE_DIALOGUE";
export const LESS_SUBCOIN_BY_ADMIN = "LESS_SUBCOIN_BY_ADMIN";

export const GET_SUBCOINSELLER_HISTORY = "GET_SUBCOINSELLER_HISTORY";
export const SHOW_SUBCOINSELLER = "SHOW_SUBCOINSELLER";

export const ADD_COIN_TO_SUPPER_DIALOGUE = "ADD_COIN_TO_SUPPER_SELLER";
export const ADD_COIN_TO_SUPPE_CLOSE_DIALOGUE =
  "ADD_COIN_TO_SUPPE_CLOSE_DIALOGUE";

export const ADD_COIN_TO_SUB_SELLER_DIALOGUE =
  "ADD_COIN_TO_SUB_SELLER_DIALOGUE";
export const ADD_COIN_TO_SUB_SELLER_CLOSE_DIALOGUE =
  "ADD_COIN_TO_SUB_SELLER_CLOSE_DIALOGUE";
